var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { ataEndTypesAllowed, arEndTypesAllowed, ORDER_EVENT_NAMES, ORDER_UPDATE_TYPES } from '../shared/constants';
import { RideTrackerMapService } from './ride-tracker-map.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { ToasterService } from 'src/app/toaster.service';
import { TollsService } from '../tolls.service';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { generateMultiPolygonFromSet } from '../shared/utils/h3.utils';
import { HelperService } from '../helper.service';
var RideTrackerMapComponent = /** @class */ (function () {
    function RideTrackerMapComponent(rideTrackerMapService, toasterService, tollService) {
        this.rideTrackerMapService = rideTrackerMapService;
        this.toasterService = toasterService;
        this.tollService = tollService;
        this.fullViewMap = new EventEmitter();
        this.faRefresh = faRedo;
        this.slideOptions = [];
        this.markerWithPositions = {};
        this.captLiveLocInOrderLogs = false;
        this.bound = new google.maps.LatLngBounds(null);
        this.isServiceDeliveryType = false;
        this.requestedEvent = {};
        this.startedEvent = {};
        // setting markers
        this.infowindow = new google.maps.InfoWindow();
        this.abortMarker = new google.maps.Marker();
        this.arrivedMarker = new google.maps.Marker();
        this.captainCancelledMarker = new google.maps.Marker();
        this.customerCancelledMarker = new google.maps.Marker();
        this.droppedMarker = new google.maps.Marker();
        this.newMarker = new google.maps.Marker();
        this.onTheWayMarker = new google.maps.Marker();
        this.expiredMarker = new google.maps.Marker();
        this.startedMarker = new google.maps.Marker();
        this.reachedMarker = new google.maps.Marker();
        this.captainLiveMarker = new google.maps.Marker();
        this.dropChangedMarker = new google.maps.Marker();
        this.acceptRouteTitle = 'First Mile Travelled';
        // Setting icons
        this.abortedIcon = {
            url: '../../assets/map/aborted.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.arrivedIcon = {
            url: '../../assets/map/arrived.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.captainCancelledIcon = {
            url: '../../assets/map/captain-cancelled.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.customerCancelledIcon = {
            url: '../../assets/map/customer-cancelled.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.droppedIcon = {
            url: '../../assets/map/dropped.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.multipleStatusIcon = {
            url: '../../assets/map/multiple-status.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.newIcon = {
            url: '../../assets/map/new.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.otwIcon = {
            url: '../../assets/map/on-the-way.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.expiredIcon = {
            url: '../../assets/map/order-expired.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.startedIcon = {
            url: '../../assets/map/started.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.reachedIcon = {
            url: '../../assets/map/reached.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.dropChangedIcon = {
            url: '../../assets/map/dropped.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.polyStart = {
            url: '../../assets/map/polystart.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.polyEnd = {
            url: '../../assets/map/polyend.png',
            scaledSize: new google.maps.Size(35, 50)
        };
        this.actualRouteMarker = {
            url: '../../assets/map/actualRoute.png',
            scaledSize: new google.maps.Size(10, 10)
        };
        this.acceptToArriveRouteMarker = {
            url: '../../assets/map/acceptToArriveRoute.png',
            scaledSize: new google.maps.Size(10, 10)
        };
        this.captainLiveIcon = {
            url: '../../assets/map/bike.png',
            scaledSize: new google.maps.Size(30, 30)
        };
        this.startedInitialMarker = new google.maps.Marker();
        this.endInitialMarker = new google.maps.Marker();
        this.startedFinalMarker = new google.maps.Marker();
        this.endFinalMarker = new google.maps.Marker();
        // actual route
        this.actualRoute = [];
        this.arEndTypesAllowed = arEndTypesAllowed;
        // accept to arrive route
        this.acceptToArriveRoute = [];
        this.ataEndTypesAllowed = ataEndTypesAllowed;
        // Alternate routes
        this.otherRoutes = [];
        this.startedOtherMarker = new Array();
        this.endOtherMarker = new Array();
        this.colorsForOtherRoutes = ['#0000FF', '#753a88'];
        this.captLiveCoords = { lat: null, lng: null };
        // status mapping
        this.statusMap = {
            '2': 'On Duty',
            '2-6': 'On Duty On Way',
            '4': 'Logged out',
            '5': 'Unreachable',
            '6': 'On The Way',
            '7': 'Arrived',
            '8': 'Started',
            '8-6': 'Started On Way',
            '8-2': 'Started On Duty',
            '9': 'Offline',
            '10': 'Reached'
        };
        this.terminalStates = ['4', '5', '9'];
        this.isFirstMileTriggered = false;
        this.isLastMileTriggered = false;
        this.statusRed = ['customerCancelled', 'riderRejected', 'expired', 'aborted', 'riderCancelled', 'dropped'];
        this.showCaptainLocationRefresh = false;
        this.selectedOptions = {
            'Initial set route': false, 'Final estimated route': false, 'Last Mile Travelled(hF)': false, 'ODRD(Actual) route': false, 'Order Log Points': false,
            'First Mile Travelled': false, 'Alternate routes': false, 'Captain live location': true, 'Tolls': true, 'Guest Route': false, 'Host Route': false, 'Match Route': false, 'Host Actual Route': false
        };
        this.cityBoundaryPolygon = {};
        this.cityTolls = [];
        this.tollPolylines = [];
        this.cityEntryTollLines = [];
        this.cityExitTollLines = [];
        this.tollEnabled = false;
        this.startedGuestMarker = new google.maps.Marker();
        this.endGuestMarker = new google.maps.Marker();
        this.startedHostMarker = new google.maps.Marker();
        this.endHostMarker = new google.maps.Marker();
        this.startedMatchMarker = new google.maps.Marker();
        this.endMatchMarker = new google.maps.Marker();
        // host actual route
        this.hostActualRoute = [];
        this.isHostActualRouteTriggered = false;
        this.hostActualRouteStartBufferMinutes = 30; // configurable buffer in minutes
        this.hostActualRouteEndBufferMinutes = 30; // configurable buffer in minutes
    }
    RideTrackerMapComponent.prototype.ngOnInit = function () {
        this.mapProperties = {
            center: new google.maps.LatLng(21.7679, 78.8718),
            zoom: 5,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            clickableIcons: false,
            gestureHandling: 'cooperative'
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapProperties);
        this.startedOtherMarker[0] = this.startedOtherMarker[1] = new google.maps.Marker();
        this.endOtherMarker[0] = this.endOtherMarker[1] = new google.maps.Marker();
    };
    RideTrackerMapComponent.prototype.ngOnChanges = function (changes) {
        this.isServiceDeliveryType = this.mapData.fareEstimateLogs ? this.mapData.fareEstimateLogs[0].service.serviceType == 'delivery' : false;
        this.requestedEvent = this.mapData.events ? this.mapData.events.find(function (event) { return event.eventName == 'requested'; }) : null;
        this.startedEvent = this.mapData.events ? this.mapData.events.find(function (event) { return event.eventName == 'started'; }) : null;
        if (changes) {
            if (this.orderCityId) {
                this.addCityBoundary();
            }
            if (changes.mapData && changes.mapData.currentValue) {
                this.getAcceptToArriveRoute();
                this.getActualRoute();
                if (this.orderStatus) {
                    if (this.statusRed.indexOf(this.orderStatus) === -1) {
                        this.showCaptainLocationRefresh = true;
                        this.getCaptLiveLocation();
                    }
                    if (this.orderStatus === 'customerCancelled') {
                        this.captLiveLocInOrderLogs = true;
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.addCityBoundary = function () {
        var _this = this;
        this.rideTrackerMapService.getCityInfo(this.orderCityId).subscribe(function (result) {
            var cityBoundary = [];
            var hexIds = result.length > 0 ? result[0].hexIds : [];
            var hexBoundary = generateMultiPolygonFromSet(hexIds);
            hexBoundary[0][0].map(function (point) { return cityBoundary.push({ latitude: point[1], longitude: point[0] }); });
            if (cityBoundary) {
                cityBoundary = cityBoundary.reduce(function (acc, x) {
                    if (isNaN(x["latitude"]) || isNaN(x["longitude"]) || x["latitude"] === null || x["longitude"] === null) {
                        return acc;
                    }
                    else {
                        acc.push({ lat: x["latitude"], lng: x["longitude"] });
                        return acc;
                    }
                }, []);
                var cityPolygon = new google.maps.Polygon({
                    paths: cityBoundary,
                    fillOpacity: 0
                });
                _this.cityBoundaryPolygon = cityPolygon;
                cityPolygon.setMap(_this.map);
            }
        }, function (err) {
            console.log("unable to load city boundary", err);
        });
    };
    RideTrackerMapComponent.prototype.changeInOption = function (option) {
        switch (option) {
            case 'Initial set route':
                this.toggleInitialRoute();
                break;
            case 'Final estimated route':
                this.toggleFinalRoute();
                break;
            case 'ODRD(Actual) route':
                this.toggleOdrdRoute();
                break;
            case 'Last Mile Travelled(hF)':
                this.toggleActualRoute();
                break;
            case 'Order Log Points':
                this.toggleOrderLogsView();
                break;
            case 'First Mile Travelled':
                this.toggleAcceptToArriveRoute();
                break;
            case 'Alternate routes':
                this.toggleOtherRoutes();
                break;
            case 'Tolls':
                this.togglePopulateTolls();
                break;
            case 'Guest Route':
                this.toggleGuestRoute();
                break;
            case 'Host Route':
                this.toggleHostRoute();
                break;
            case 'Match Route':
                this.toggleMatchRoute();
                break;
            case 'Host Actual Route':
                this.toggleHostActualRoute();
                break;
        }
    };
    RideTrackerMapComponent.prototype.showInfowindow = function (dataToShow, marker) {
        var infowindow = new google.maps.InfoWindow({
            content: dataToShow,
        });
        infowindow.open(this.map, marker);
    };
    RideTrackerMapComponent.prototype.getFareEstimates = function () {
        var _this = this;
        if (this.mapData && this.mapData.requestId) {
            var fareEstimateData_1 = [];
            this.rideTrackerMapService.getOrderRequests(this.mapData.requestId, localStorage.getItem('userId') || '').subscribe(function (result) {
                if (result && result['data']) {
                    fareEstimateData_1.push({ allPaths: result['data'].allPaths || [] });
                }
                _this.mapData.fareEstimateLogs = fareEstimateData_1;
            });
        }
    };
    RideTrackerMapComponent.prototype.toggleOrderLogsView = function () {
        var _this = this;
        if (this.selectedOptions['Order Log Points']) {
            if (this.captLiveLocInOrderLogs) {
                if (this.cancellationInformation && this.cancellationInformation.captainLocation &&
                    this.cancellationInformation.captainLocation.length === 2) {
                    var latLng = { lat: this.cancellationInformation.captainLocation[1], lng: this.cancellationInformation.captainLocation[0] };
                    this.extendBounds(latLng);
                    this.captainLiveMarker.setPosition(latLng);
                    this.captainLiveMarker.setMap(this.map);
                    this.captainLiveMarker.setIcon(this.captainLiveIcon);
                    var dataToShow_1 = 'Captain location on cancellation';
                    this.showInfowindow(dataToShow_1, this.captainLiveMarker);
                    this.captainLiveMarker.addListener('click', function () {
                        _this.showInfowindow(dataToShow_1, _this.captainLiveMarker);
                    });
                }
            }
            var _loop_1 = function (log) {
                if (this_1.markerWithPositions[log]) {
                    var logs = this_1.markerWithPositions[log];
                    switch (logs.icon) {
                        case 'new':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.newMarker.setPosition(latLng);
                                this_1.newMarker.setMap(this_1.map);
                                this_1.newMarker.setIcon(this_1.newIcon);
                                var dataToShow_2 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_2, this_1.newMarker);
                                this_1.newMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_2, _this.newMarker);
                                });
                            }
                            break;
                        case 'accepted':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.onTheWayMarker.setPosition(latLng);
                                this_1.onTheWayMarker.setMap(this_1.map);
                                this_1.onTheWayMarker.setIcon(this_1.otwIcon);
                                var dataToShow_3 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_3, this_1.onTheWayMarker);
                                this_1.onTheWayMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_3, _this.onTheWayMarker);
                                });
                            }
                            break;
                        case 'arrived':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.arrivedMarker.setPosition(latLng);
                                this_1.arrivedMarker.setMap(this_1.map);
                                this_1.arrivedMarker.setIcon(this_1.arrivedIcon);
                                var dataToShow_4 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_4, this_1.arrivedMarker);
                                this_1.arrivedMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_4, _this.arrivedMarker);
                                });
                            }
                            break;
                        case 'started':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.startedMarker.setPosition(latLng);
                                this_1.startedMarker.setMap(this_1.map);
                                this_1.startedMarker.setIcon(this_1.startedIcon);
                                var dataToShow_5 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_5, this_1.startedMarker);
                                this_1.startedMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_5, _this.startedMarker);
                                });
                            }
                            break;
                        case 'reached':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.reachedMarker.setPosition(latLng);
                                this_1.reachedMarker.setMap(this_1.map);
                                this_1.reachedMarker.setIcon(this_1.reachedIcon);
                                var dataToShow_6 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_6, this_1.reachedMarker);
                                this_1.reachedMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_6, _this.reachedMarker);
                                });
                            }
                            break;
                        case 'dropped':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.droppedMarker.setPosition(latLng);
                                this_1.droppedMarker.setMap(this_1.map);
                                this_1.droppedMarker.setIcon(this_1.droppedIcon);
                                var dataToShow_7 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_7, this_1.droppedMarker);
                                this_1.droppedMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_7, _this.droppedMarker);
                                });
                            }
                            break;
                        case 'customer_cancelled':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.customerCancelledMarker.setPosition(latLng);
                                this_1.customerCancelledMarker.setMap(this_1.map);
                                this_1.customerCancelledMarker.setIcon(this_1.customerCancelledIcon);
                                var dataToShow_8 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_8, this_1.customerCancelledMarker);
                                this_1.customerCancelledMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_8, _this.customerCancelledMarker);
                                });
                            }
                            break;
                        case 'captain_cancelled':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                // this.extendBounds(latLng);
                                this_1.captainCancelledMarker.setPosition(latLng);
                                this_1.captainCancelledMarker.setMap(this_1.map);
                                this_1.captainCancelledMarker.setIcon(this_1.captainCancelledIcon);
                                var dataToShow_9 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_9, this_1.captainCancelledMarker);
                                this_1.captainCancelledMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_9, _this.captainCancelledMarker);
                                });
                            }
                            break;
                        case 'expired':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.expiredMarker.setPosition(latLng);
                                this_1.expiredMarker.setMap(this_1.map);
                                this_1.expiredMarker.setIcon(this_1.expiredIcon);
                                var dataToShow_10 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_10, this_1.expiredMarker);
                                this_1.expiredMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_10, _this.expiredMarker);
                                });
                            }
                            break;
                        case 'aborted':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.abortMarker.setPosition(latLng);
                                this_1.abortMarker.setMap(this_1.map);
                                this_1.abortMarker.setIcon(this_1.abortedIcon);
                                var dataToShow_11 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_11, this_1.abortMarker);
                                this_1.abortMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_11, _this.abortMarker);
                                });
                            }
                            break;
                        case 'multiple':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                var marker_1 = new google.maps.Marker();
                                marker_1.setPosition(latLng);
                                marker_1.setMap(this_1.map);
                                marker_1.setIcon(this_1.multipleStatusIcon);
                                var dataToShow_12 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_12, marker_1);
                                marker_1.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_12, marker_1);
                                });
                            }
                            break;
                        case 'dropChanged':
                            if (logs && logs.lat && logs.lng) {
                                var latLng = { lat: logs.lat, lng: logs.lng };
                                this_1.extendBounds(latLng);
                                this_1.dropChangedMarker.setPosition(latLng);
                                this_1.dropChangedMarker.setMap(this_1.map);
                                this_1.dropChangedMarker.setIcon(this_1.dropChangedIcon);
                                var dataToShow_13 = this_1.getMarkerInfo(logs.label);
                                this_1.showInfowindow(dataToShow_13, this_1.dropChangedMarker);
                                this_1.dropChangedMarker.addListener('click', function () {
                                    _this.showInfowindow(dataToShow_13, _this.dropChangedMarker);
                                });
                            }
                            break;
                    }
                    this_1.map.setCenter(this_1.bound.getCenter());
                }
            };
            var this_1 = this;
            for (var log in this.markerWithPositions) {
                _loop_1(log);
            }
        }
        else {
            this.abortMarker.setMap(null);
            this.arrivedMarker.setMap(null);
            this.captainCancelledMarker.setMap(null);
            this.customerCancelledMarker.setMap(null);
            this.droppedMarker.setMap(null);
            this.newMarker.setMap(null);
            this.onTheWayMarker.setMap(null);
            this.expiredMarker.setMap(null);
            this.startedMarker.setMap(null);
            this.dropChangedMarker.setMap(null);
        }
    };
    RideTrackerMapComponent.prototype.toggleCaptLiveLoc = function () {
        var _this = this;
        if (this.captLiveCoords && this.captLiveCoords.lat && this.captLiveCoords.lng) {
            var latLng = this.captLiveCoords;
            this.extendBounds(latLng);
            this.captainLiveMarker.setPosition(latLng);
            this.captainLiveMarker.setMap(this.map);
            this.captainLiveMarker.setIcon(this.captainLiveIcon);
            this.showInfowindow('Captain is ' + this.statusMap[this.captainCurrentStatus], this.captainLiveMarker);
            this.captainLiveMarker.addListener('click', function () {
                _this.showInfowindow('Captain is ' + _this.statusMap[_this.captainCurrentStatus], _this.captainLiveMarker);
            });
        }
    };
    RideTrackerMapComponent.prototype.isEmpty = function (value) {
        return (value == null || value.length === 0);
    };
    RideTrackerMapComponent.prototype.constructSideBar = function () {
        this.slideOptions = [];
        if (this.mapData) {
            var data = this.mapData.fareEstimateLogs || [];
            var finalAllPaths = data[0] && data[0].direction && data[0].direction.allPaths;
            var dataLength = data.length;
            var isInitialRouteToggleDisabled = false;
            var isFinalRouteToggleDisabled = false;
            if (this.isServiceDeliveryType) {
                isInitialRouteToggleDisabled = !this.requestedEvent;
                isFinalRouteToggleDisabled = !this.startedEvent;
            }
            else {
                isInitialRouteToggleDisabled = !(data[dataLength - 1] && data[dataLength - 1].direction.allPaths && data[dataLength - 1].direction.allPaths.length > 0);
                isFinalRouteToggleDisabled = !(finalAllPaths && finalAllPaths.length > 0);
            }
            if (dataLength > 0 && data[dataLength - 1] && data[dataLength - 1].direction) {
                this.slideOptions.push({
                    title: 'Initial set route',
                    distance: !this.isEmpty(data[dataLength - 1].direction.distanceInKms) ?
                        (data[dataLength - 1].direction.distanceInKms) + ' kms' : 'N/A',
                    time: !this.isEmpty(data[dataLength - 1].direction.timeInMins) ?
                        (data[dataLength - 1].direction.timeInMins) + ' mins' : 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: isInitialRouteToggleDisabled
                });
            }
            else {
                this.slideOptions.push({
                    title: 'Initial set route',
                    distance: 'N/A',
                    time: 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: isInitialRouteToggleDisabled
                });
            }
            if (dataLength > 0 && data[0] && data[0].direction) {
                this.slideOptions.push({ title: 'Final estimated route',
                    distance: this.mapData && this.mapData.finalEstimatedDistance ? this.mapData.finalEstimatedDistance + 'kms' :
                        data[0].direction.distanceInKms ? (data[0].direction.distanceInKms) + ' kms' : 'N/A',
                    time: this.mapData && this.mapData.finalEstimatedTime ? this.mapData.finalEstimatedTime + ' mins' :
                        data[0].direction.timeInMins ? (data[0].direction.timeInMins) + ' mins' : 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: isFinalRouteToggleDisabled
                });
            }
            else {
                this.slideOptions.push({ title: 'Final estimated route',
                    distance: 'N/A',
                    time: 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: isFinalRouteToggleDisabled
                });
            }
            this.slideOptions.push({
                title: 'Last Mile Travelled(hF)',
                distance: this.mapData && this.mapData.finalDistance ?
                    ((parseFloat(this.mapData.finalDistance)).toFixed(2)).toString() + ' kms' : 'N/A',
                time: this.mapData && this.mapData.finalRideTime ? this.mapData.finalRideTime + ' mins' : 'N/A',
                polyline: '',
                addLine: true,
                disabled: !(this.actualLatLngs && this.actualLatLngs.locations && this.actualLatLngs.locations.length > 0)
            });
            if (this.mapData && this.mapData.odrdPolyline && this.mapData.odrdDistance) {
                this.slideOptions.push({ title: 'ODRD(Actual) route',
                    distance: this.mapData.odrdDistance ? this.mapData.odrdDistance + ' kms' : 'N/A',
                    time: this.mapData.odrdTime ? this.mapData.odrdTime + " mins" : 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: !(this.mapData.odrdPolyline)
                });
            }
            else {
                this.slideOptions.push({ title: 'ODRD(Actual) route',
                    distance: 'N/A',
                    time: 'N/A',
                    polyline: '',
                    addLine: true,
                    disabled: !(this.mapData.odrdPolyline)
                });
            }
            this.slideOptions.push({
                title: 'First Mile Travelled',
                addLine: true,
                distance: this.acceptToArriveLatLngs && (this.acceptToArriveLatLngs.distance).toString() ?
                    (this.acceptToArriveLatLngs.distance.toFixed(2)).toString() + ' kms' : 'N/A',
                time: this.acceptToArriveLatLngs && this.acceptToArriveLatLngs.time ? this.acceptToArriveLatLngs.time.toFixed(2) + ' mins' : 'N/A',
                disabled: !(this.acceptToArriveLatLngs && this.acceptToArriveLatLngs.locations &&
                    this.acceptToArriveLatLngs.locations.length > 0)
            });
            this.slideOptions.push({
                title: 'Alternate routes',
                polyline: '',
                addLine: true,
                distance: finalAllPaths && finalAllPaths && finalAllPaths[1] && finalAllPaths[1].distance ?
                    ((finalAllPaths[1].distance / 1000).toFixed(2)).toString() + ' kms' : 'N/A',
                time: finalAllPaths && finalAllPaths && finalAllPaths[1] && finalAllPaths[1].time ?
                    ((finalAllPaths[1].time / 60).toFixed(2)).toString() + ' mins' : 'N/A',
                color: 'color-blue',
                distance2: finalAllPaths && finalAllPaths[2] && finalAllPaths[2].distance ?
                    ((finalAllPaths[2].distance / 1000).toFixed(2)).toString() + ' kms' : 'N/A',
                time2: finalAllPaths && finalAllPaths[2] && finalAllPaths[2].time ?
                    ((finalAllPaths[2].time / 60).toFixed(2)).toString() + ' mins' : 'N/A',
                color2: 'color-red',
                disabled: !(finalAllPaths && finalAllPaths.length > 1)
            });
            this.slideOptions.push({
                title: 'Order Log Points',
                distance: null,
                time: null,
                addLine: true,
                disabled: !(this.markerWithPositions)
            });
            this.slideOptions.push({
                title: 'Tolls',
                distance: null,
                time: null,
                addLine: true,
                disabled: false
            });
            // Add Pool routes if poolInfo exists
            if (this.poolInfo) {
                this.slideOptions.push({
                    title: 'Guest Route',
                    distance: this.guestTripData && this.guestTripData.routeDetails && this.guestTripData.routeDetails.distanceInMeters
                        ? ((this.guestTripData.routeDetails.distanceInMeters / 1000).toFixed(2)).toString() + ' kms' : 'N/A',
                    time: this.guestTripData && this.guestTripData.routeDetails && this.guestTripData.routeDetails.durationInSeconds
                        ? ((this.guestTripData.routeDetails.durationInSeconds / 60).toFixed(2)).toString() + ' mins' : 'N/A',
                    addLine: true,
                    disabled: !(this.poolInfo.guestTripId)
                });
                this.slideOptions.push({
                    title: 'Host Route',
                    distance: this.hostTripData && this.hostTripData.routeDetails && this.hostTripData.routeDetails.distanceInMeters
                        ? ((this.hostTripData.routeDetails.distanceInMeters / 1000).toFixed(2)).toString() + ' kms' : 'N/A',
                    time: this.hostTripData && this.hostTripData.routeDetails && this.hostTripData.routeDetails.durationInSeconds
                        ? ((this.hostTripData.routeDetails.durationInSeconds / 60).toFixed(2)).toString() + ' mins' : 'N/A',
                    addLine: true,
                    disabled: !(this.poolInfo.hostTripId)
                });
                this.slideOptions.push({
                    title: 'Match Route',
                    distance: this.tripMatchData && this.tripMatchData.pricing && this.tripMatchData.pricing.distanceInKms
                        ? (this.tripMatchData.pricing.distanceInKms).toFixed(2).toString() + ' kms' : 'N/A',
                    time: this.tripMatchData && this.tripMatchData.pricing && this.tripMatchData.pricing.timeInMins
                        ? (this.tripMatchData.pricing.timeInMins).toFixed(2).toString() + ' mins' : 'N/A',
                    addLine: true,
                    disabled: !(this.poolInfo.tripMatchId)
                });
                this.slideOptions.push({
                    title: 'Host Actual Route',
                    distance: this.hostActualLatLngs && this.hostActualLatLngs.distance !== undefined && this.hostActualLatLngs.distance !== null
                        ? (this.hostActualLatLngs.distance).toFixed(2) + ' kms' : 'N/A',
                    time: 'N/A',
                    addLine: true,
                    disabled: !(this.poolInfo && this.poolInfo.hostTripId)
                });
            }
        }
        if (!this.slideOptions[0].disabled) {
            this.firstToggle();
        }
    };
    RideTrackerMapComponent.prototype.firstToggle = function () {
        var isCorporatePool = this.poolInfo && this.poolInfo.type === 'MPMD_CORPORATE_POOL';
        // Base options - only initial route and order logs change based on pool type
        this.selectedOptions = __assign({ 'Initial set route': !isCorporatePool, 'Final estimated route': false, 'Last Mile Travelled(hF)': false, 'ODRD(Actual) route': false, 'Order Log Points': !isCorporatePool, 'First Mile Travelled': false, 'Alternate routes': false, 'Captain live location': false, 'Tolls': false }, (isCorporatePool && {
            'Guest Route': false,
            'Host Route': false,
            'Match Route': false,
            'Host Actual Route': false
        }));
        // Enable default options only for regular orders
        if (!isCorporatePool) {
            this.changeInOption('Initial set route');
            this.changeInOption('Order Log Points');
        }
    };
    RideTrackerMapComponent.prototype.getMarkerInfo = function (labels) {
        var htmlInfo = '';
        for (var label in labels) {
            if (labels[label]) {
                switch (labels[label]) {
                    case 'new':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 new-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> New Order </div>\n                </div>";
                        break;
                    case 'accepted':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 on-the-way-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> On The Way </div>\n                </div>";
                        break;
                    case 'arrived':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 arrived-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Arrived </div>\n                </div>";
                        break;
                    case 'started':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 started-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Started </div>\n                </div>";
                        break;
                    case 'reached':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 reached-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Reached </div>\n                </div>";
                        break;
                    case 'dropped':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 dropped-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Dropped </div>\n                </div>";
                        break;
                    case 'customer_cancelled':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 customer-cancelled-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Customer Cancelled </div>\n                </div>";
                        break;
                    case 'captain_cancelled':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 captain-cancelled-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Captain Cancelled </div>\n                </div>";
                        break;
                    case 'expired':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 expired-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Expired </div>\n                </div>";
                        break;
                    case 'aborted':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 aborted-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Aborted </div>\n                </div>";
                        break;
                    case 'dropChanged':
                        htmlInfo += "<div>\n                  <div class=\"circle-9 dropped-marker-color display-inline-block\"></div>\n                  <div class=\"text-info-window display-inline-block\"> Drop Changed </div>\n                </div>";
                        break;
                }
            }
        }
        return htmlInfo;
    };
    RideTrackerMapComponent.prototype.getAcceptToArriveRoute = function () {
        var _this = this;
        var startedState, endState;
        if (this.mapData && this.mapData.orderLogPoints) {
            var logs = this.mapData.orderLogPoints;
            for (var log in logs) {
                if (logs[log]) {
                    if (logs[log].eventName && logs[log].eventName === 'accepted') {
                        startedState = logs[log]['updatedAt'] ? logs[log]['updatedAt'] : '';
                    }
                    else if (startedState && logs[log].eventName && this.ataEndTypesAllowed.indexOf(logs[log].eventName) > -1) {
                        endState = logs[log]['updatedAt'] ? logs[log]['updatedAt'] : '';
                    }
                }
            }
        }
        if (!endState) {
            endState = new Date().getTime();
        }
        if (this.orderId && this.riderIdForOrder && startedState && endState && !this.isFirstMileTriggered) {
            this.isFirstMileTriggered = true;
            var body = {
                responseParams: {
                    requiredFields: [
                        "captainLocations",
                    ]
                }
            };
            this.rideTrackerMapService.getCaptainLocationsFromOrderAttribute(this.orderId, body).subscribe(function (response) {
                if (response.captainLocations && response.captainLocations[0].firstMile) {
                    var result = response.captainLocations[0].firstMile;
                    result['time'] = _this.differenceTimestamps(startedState, endState);
                    _this.acceptToArriveLatLngs = result;
                    _this.getActualRoute();
                }
                else {
                    _this.getActualRoute();
                }
            }, function (err) {
                _this.isFirstMileTriggered = false;
                _this.getActualRoute();
            });
        }
        else {
            this.getActualRoute();
        }
    };
    RideTrackerMapComponent.prototype.getActualRoute = function () {
        var _this = this;
        var started, endState;
        if (this.mapData && this.mapData.orderLogPoints) {
            var logs = this.mapData.orderLogPoints;
            for (var log in logs) {
                if (logs[log]) {
                    if (logs[log].eventName && logs[log].eventName === 'started') {
                        started = logs[log]['updatedAt'] ? logs[log]['updatedAt'] : '';
                    }
                    else if (started && logs[log].eventName && this.arEndTypesAllowed.indexOf(logs[log].eventName) > -1) {
                        endState = logs[log]['updatedAt'] ? logs[log]['updatedAt'] : '';
                    }
                }
            }
        }
        if (!endState) {
            endState = new Date().getTime();
        }
        if (this.orderId && this.riderIdForOrder && started && endState && !this.isLastMileTriggered) {
            this.isLastMileTriggered = true;
            var body = {
                responseParams: {
                    requiredFields: [
                        "captainLocations",
                    ]
                }
            };
            this.rideTrackerMapService.getCaptainLocationsFromOrderAttribute(this.orderId, body).subscribe(function (response) {
                _this.actualLatLngs = response.captainLocations[0].lastMile;
                _this.constructSideBar();
                _this.getMarkers();
            }, function (err) {
                _this.isLastMileTriggered = false;
                _this.getSideBar();
            });
        }
        else {
            this.getSideBar();
        }
    };
    /**
     * Calculate start time epoch in milliseconds from trip date and start time in seconds (in IST)
     * tripDate: "YYYY-MM-DD" representing a date in IST
     * startTimeForDayInSeconds: seconds elapsed since IST midnight
     * IST = UTC+5:30, so IST midnight = UTC previous day 18:30
     * Subtracts configurable buffer (default 30 minutes)
     */
    // For HOPR orders, we need to calculate the start time based on the trip date and start time in seconds (in IST)
    RideTrackerMapComponent.prototype.calculateHostActualRouteStartTime = function (tripDate, startTimeForDayInSeconds, bufferMinutes) {
        if (bufferMinutes === void 0) { bufferMinutes = 30; }
        if (!tripDate || !startTimeForDayInSeconds) {
            return null;
        }
        // Parse date string (format: "2026-02-17")
        var dateParts = tripDate.split('-');
        if (dateParts.length !== 3) {
            console.error('Invalid date format. Expected YYYY-MM-DD format.');
            return null;
        }
        var year = parseInt(dateParts[0], 10);
        var month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed
        var day = parseInt(dateParts[2], 10);
        // Validate parsed values
        if (isNaN(year) || isNaN(month) || isNaN(day)) {
            console.error('Invalid date values. Could not parse date string:', tripDate);
            return null;
        }
        // Validate month range (0-11 after subtracting 1)
        if (month < 0 || month > 11) {
            console.error('Invalid month value:', month + 1);
            return null;
        }
        // Validate day range (basic check)
        if (day < 1 || day > 31) {
            console.error('Invalid day value:', day);
            return null;
        }
        // IST offset: +5 hours 30 minutes = 19800 seconds = 19800000 ms
        var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
        // Midnight IST in epoch ms = UTC midnight - IST offset
        var midnightISTEpochMs = Date.UTC(year, month, day) - IST_OFFSET_MS;
        // Add startTimeForDayInSeconds (seconds from IST midnight) to get the start time
        var startTimeEpochMs = midnightISTEpochMs + (startTimeForDayInSeconds * 1000);
        // Subtract buffer (convert minutes to milliseconds)
        return startTimeEpochMs - (bufferMinutes * 60 * 1000);
    };
    /**
     * Calculate end time epoch in milliseconds
     * End time = start time + 5 hours
     * If current time < start time + 5 hours, use current time
     * Otherwise use start time + 5 hours
     */
    RideTrackerMapComponent.prototype.calculateHostActualRouteEndTime = function (startTime) {
        if (!startTime) {
            return null;
        }
        var currentTime = new Date().getTime();
        var fiveHoursInMs = 5 * 60 * 60 * 1000;
        var endTimeFromStart = startTime + fiveHoursInMs;
        // Use the minimum of (start time + 5 hours) and current time
        return Math.min(endTimeFromStart, currentTime);
    };
    /**
     * Get host actual route from Cassandra API
     */
    RideTrackerMapComponent.prototype.getHostActualRoute = function () {
        var _this = this;
        if (!this.poolInfo || !this.poolInfo.hostTripId) {
            this.getSideBar();
            return;
        }
        if (!this.hostTripData) {
            // Fetch hostTripData first, then proceed with actual route
            this.rideTrackerMapService.getTripsBulk([this.poolInfo.hostTripId], this.poolInfo.tripDate).subscribe(function (result) {
                var trip = HelperService.tripFromBulkResponse(result, _this.poolInfo.hostTripId, _this.poolInfo.tripDate);
                if (trip) {
                    _this.hostTripData = trip;
                }
                if (_this.hostTripData) {
                    _this.getHostActualRoute();
                }
                else {
                    _this.getSideBar();
                }
            }, function (error) {
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: 'Failed to fetch host trip data'
                }));
                _this.getSideBar();
            });
            return;
        }
        var tripDate = this.poolInfo.tripDate;
        var startTimeForDayInSeconds = this.hostTripData.startTimeForDayInSeconds;
        var hostCaptainId = this.hostTripData.captainId || this.riderIdForOrder;
        if (!tripDate || !startTimeForDayInSeconds || !hostCaptainId || this.isHostActualRouteTriggered) {
            this.getSideBar();
            return;
        }
        // Calculate start and end times using modular functions
        var startTime = this.calculateHostActualRouteStartTime(tripDate, startTimeForDayInSeconds, this.hostActualRouteStartBufferMinutes);
        var endTime = this.calculateHostActualRouteEndTime(startTime);
        if (!startTime || !endTime) {
            this.getSideBar();
            return;
        }
        this.isHostActualRouteTriggered = true;
        this.rideTrackerMapService.getActualRoute(hostCaptainId, startTime, endTime).subscribe(function (response) {
            console.log('startTime', startTime, 'endTime', endTime, 'Hhahahahahahahahahahaha', response);
            if (response && response.locations && response.locations.length > 0) {
                _this.hostActualLatLngs = {
                    locations: response.locations,
                    distance: response.distance
                };
                _this.constructSideBar();
                _this.getMarkers();
                // If toggle is already on, display the markers
                if (_this.selectedOptions['Host Actual Route']) {
                    _this.displayHostActualRouteMarkers();
                }
            }
            else {
                _this.isHostActualRouteTriggered = false;
                _this.getSideBar();
            }
        }, function (err) {
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Failed to fetch host actual route'
            }));
            _this.isHostActualRouteTriggered = false;
            _this.getSideBar();
        });
    };
    /**
     * Display host actual route markers on map
     */
    RideTrackerMapComponent.prototype.displayHostActualRouteMarkers = function () {
        var _this = this;
        // Clear existing markers first
        if (this.hostActualRoute && this.hostActualRoute.length > 0) {
            for (var position in this.hostActualRoute) {
                if (this.hostActualRoute[position]) {
                    this.hostActualRoute[position].setMap(null);
                }
            }
        }
        this.hostActualRoute = [];
        var points = this.hostActualLatLngs && this.hostActualLatLngs.locations;
        console.log('displayHostActualRouteMarkers - points:', points, 'length:', points ? points.length : 0);
        if (points && points.length > 0) {
            // Create bounds for zooming
            var bounds = new google.maps.LatLngBounds();
            var _loop_2 = function (i) {
                var point = points[i];
                if (point && point.location && point.location.length >= 2) {
                    var latLng = { lat: point.location[1], lng: point.location[0] };
                    var marker_2 = new google.maps.Marker({
                        position: latLng,
                        icon: this_2.actualRouteMarker,
                        map: this_2.map
                    });
                    // Add click listener to show location info
                    var timestamp = point.date ? new Date(point.date).toLocaleString() : 'N/A';
                    var infoContent_1 = "\n            <div style=\"padding: 5px;\">\n              <strong>Location Details</strong><br>\n              Latitude: " + latLng.lat.toFixed(6) + "<br>\n              Longitude: " + latLng.lng.toFixed(6) + "<br>\n              Timestamp: " + timestamp + "\n            </div>\n          ";
                    marker_2.addListener('click', function () {
                        _this.showInfowindow(infoContent_1, marker_2);
                    });
                    this_2.hostActualRoute.push(marker_2);
                    // Extend bounds to include this location
                    bounds.extend(latLng);
                }
            };
            var this_2 = this;
            for (var i = 0; i < points.length; i++) {
                _loop_2(i);
            }
            console.log('Total markers created:', this.hostActualRoute.length);
            // Zoom map to fit all markers
            if (this.hostActualRoute.length > 0) {
                this.map.fitBounds(bounds, 100);
            }
        }
    };
    /**
     * Toggle host actual route display on map
     */
    RideTrackerMapComponent.prototype.toggleHostActualRoute = function () {
        if (this.selectedOptions['Host Actual Route']) {
            // Fetch route data if not already fetched
            if (!this.hostActualLatLngs) {
                this.getHostActualRoute();
                return;
            }
            // Display route markers
            this.displayHostActualRouteMarkers();
        }
        else {
            // Hide route markers
            if (this.hostActualRoute.length > 0) {
                for (var position in this.hostActualRoute) {
                    if (this.hostActualRoute[position]) {
                        this.hostActualRoute[position].setMap(null);
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.getCaptLiveLocation = function () {
        var _this = this;
        if (this.riderIdForOrder) {
            this.rideTrackerMapService.getLiveLocation(this.riderIdForOrder).subscribe(function (res) {
                if (res && res['location'] && res['location'].length === 2) {
                    _this.captLiveCoords.lng = res['location'][0];
                    _this.captLiveCoords.lat = res['location'][1];
                    _this.captainCurrentStatus = res['status'] || '5';
                    _this.toggleCaptLiveLoc();
                }
            });
        }
    };
    RideTrackerMapComponent.prototype.getSideBar = function () {
        this.constructSideBar();
        this.getMarkers();
    };
    RideTrackerMapComponent.prototype.getMarkers = function () {
        if (this.mapData && this.mapData.orderLogPoints) {
            this.markerWithPositions = {};
            for (var item in this.mapData.orderLogPoints) {
                if (this.mapData.orderLogPoints[item]) {
                    var log = this.mapData.orderLogPoints[item];
                    // Handle drop change events - extract location from dropLocation field
                    if (log.eventName === ORDER_EVENT_NAMES.ORDER_UPDATED && log.updateType === ORDER_UPDATE_TYPES.DROP_LOCATION && log.dropLocation && log.dropLocation.lat && log.dropLocation.lng) {
                        var latLng = log.dropLocation.lat + ', ' + log.dropLocation.lng;
                        if (this.markerWithPositions[latLng]) {
                            this.markerWithPositions[latLng] = {
                                icon: 'multiple',
                                label: this.markerWithPositions[latLng].label.concat(['dropChanged']),
                                lat: log.dropLocation.lat,
                                lng: log.dropLocation.lng
                            };
                        }
                        else {
                            this.markerWithPositions[latLng] = {
                                icon: 'dropChanged',
                                label: ['dropChanged'],
                                lat: log.dropLocation.lat,
                                lng: log.dropLocation.lng
                            };
                        }
                    }
                    else if (log.eventName && log.captainLocation && log.captainLocation.lat && log.captainLocation.lng) {
                        var latLng = log.captainLocation.lat + ', ' + log.captainLocation.lng;
                        if (this.markerWithPositions[latLng]) {
                            this.markerWithPositions[latLng] = {
                                icon: 'multiple',
                                label: this.markerWithPositions[latLng].label.concat([log.eventName]),
                                lat: log.captainLocation.lat,
                                lng: log.captainLocation.lng
                            };
                        }
                        else {
                            this.markerWithPositions[latLng] = {
                                icon: log.eventName,
                                label: [log.eventName],
                                lat: log.captainLocation.lat,
                                lng: log.captainLocation.lng
                            };
                        }
                    }
                    else if (log.eventName && log.customerLocation && log.customerLocation.lat && log.customerLocation.lng) {
                        var latLng = log.customerLocation.lat + ', ' + log.customerLocation.lng;
                        if (this.markerWithPositions[latLng]) {
                            this.markerWithPositions[latLng] = {
                                icon: 'multiple',
                                label: this.markerWithPositions[latLng].label.concat([log.eventName]),
                                lat: log.customerLocation.lat,
                                lng: log.customerLocation.lng
                            };
                        }
                        else {
                            this.markerWithPositions[latLng] = {
                                icon: log.eventName,
                                label: [log.eventName],
                                lat: log.customerLocation.lat,
                                lng: log.customerLocation.lng
                            };
                        }
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.toggleInitialRoute = function () {
        if (this.selectedOptions['Initial set route']) {
            if (this.isServiceDeliveryType && this.requestedEvent) {
                var initialPosition = { lat: this.requestedEvent.pickupLocation.lat, lng: this.requestedEvent.pickupLocation.lng };
                var finalPosition = { lat: this.requestedEvent.dropLocation.lat, lng: this.requestedEvent.dropLocation.lng };
                this.startedInitialMarker.setIcon(this.polyStart);
                this.startedInitialMarker.setPosition(initialPosition);
                this.startedInitialMarker.setMap(this.map);
                var infowindow = new google.maps.InfoWindow({
                    content: 'Customer set pickup location',
                });
                infowindow.open(this.map, this.startedInitialMarker);
                this.endInitialMarker.setIcon(this.polyEnd);
                this.endInitialMarker.setPosition(finalPosition);
                this.endInitialMarker.setMap(this.map);
                var infowindow2 = new google.maps.InfoWindow({
                    content: 'Customer set drop location',
                });
                infowindow2.open(this.map, this.endInitialMarker);
                this.extendBounds(initialPosition);
                this.extendBounds(finalPosition);
            }
            else {
                var encodedStr = this.mapData.fareEstimateLogs[this.mapData.fareEstimateLogs.length - 1].direction.polyline;
                var initialPath = google.maps.geometry.encoding.decodePath(encodedStr);
                if (this.initialRoute) {
                    this.initialRoute.setMap(null);
                }
                this.initialRoute = new google.maps.Polyline({
                    path: initialPath,
                    geodesic: true,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 3
                });
                this.startedInitialMarker.setIcon(this.polyStart);
                this.startedInitialMarker.setPosition(this.initialRoute.getPath().getAt(0));
                this.startedInitialMarker.setMap(this.map);
                var infowindow = new google.maps.InfoWindow({
                    content: 'Customer set pickup location',
                });
                infowindow.open(this.map, this.startedInitialMarker);
                this.endInitialMarker.setIcon(this.polyEnd);
                this.endInitialMarker.setPosition(this.initialRoute.getPath().getAt(this.initialRoute.getPath().getLength() - 1));
                this.endInitialMarker.setMap(this.map);
                var infowindow2 = new google.maps.InfoWindow({
                    content: 'Customer set drop location',
                });
                infowindow2.open(this.map, this.endInitialMarker);
                for (var i = 0; i < initialPath.length; i++) {
                    this.extendBounds(initialPath[i]);
                }
                this.initialRoute.setMap(this.map);
            }
        }
        else {
            if (this.initialRoute) {
                this.initialRoute.setMap(null);
            }
            this.startedInitialMarker.setMap(null);
            this.endInitialMarker.setMap(null);
        }
    };
    RideTrackerMapComponent.prototype.toggleFinalRoute = function () {
        if (this.selectedOptions['Final estimated route']) {
            if (this.isServiceDeliveryType) {
                var initialPosition = { lat: this.startedEvent.pickupLocation.lat, lng: this.startedEvent.pickupLocation.lng };
                var finalPosition = { lat: this.startedEvent.dropLocation.lat, lng: this.startedEvent.dropLocation.lng };
                this.startedFinalMarker.setIcon(this.polyStart);
                this.startedFinalMarker.setPosition(initialPosition);
                this.startedFinalMarker.setMap(this.map);
                var infowindow = new google.maps.InfoWindow({
                    content: 'Customer pickup location',
                });
                infowindow.open(this.map, this.startedFinalMarker);
                this.endFinalMarker.setIcon(this.polyEnd);
                this.endFinalMarker.setPosition(finalPosition);
                this.endFinalMarker.setMap(this.map);
                var infowindow2 = new google.maps.InfoWindow({
                    content: 'Customer drop location',
                });
                infowindow2.open(this.map, this.endFinalMarker);
                this.extendBounds(initialPosition);
                this.extendBounds(finalPosition);
            }
            else {
                var encodedStr = this.mapData && this.mapData.finalEstimatedPolyline ? this.mapData.finalEstimatedPolyline : this.mapData.fareEstimateLogs[0].direction.polyline;
                var finalPath = google.maps.geometry.encoding.decodePath(encodedStr);
                for (var i = 0; i < finalPath.length; i++) {
                    this.extendBounds(finalPath[i]);
                }
                this.finalRoute = new google.maps.Polyline({
                    path: finalPath,
                    geodesic: true,
                    strokeColor: '#0FB27D',
                    strokeOpacity: 1.0,
                    strokeWeight: 3
                });
                this.startedFinalMarker.setIcon(this.polyStart);
                this.startedFinalMarker.setPosition(this.finalRoute.getPath().getAt(0));
                this.startedFinalMarker.setMap(this.map);
                var infowindow = new google.maps.InfoWindow({
                    content: 'Customer pickup location',
                });
                infowindow.open(this.map, this.startedFinalMarker);
                this.endFinalMarker.setIcon(this.polyEnd);
                this.endFinalMarker.setPosition(this.finalRoute.getPath().getAt(this.finalRoute.getPath().getLength() - 1));
                this.endFinalMarker.setMap(this.map);
                var infowindow2 = new google.maps.InfoWindow({
                    content: 'Customer drop location',
                });
                infowindow2.open(this.map, this.endFinalMarker);
                this.finalRoute.setMap(this.map);
            }
        }
        else {
            if (this.finalRoute) {
                this.finalRoute.setMap(null);
            }
            this.startedFinalMarker.setMap(null);
            this.endFinalMarker.setMap(null);
        }
    };
    RideTrackerMapComponent.prototype.toggleOdrdRoute = function () {
        if (this.selectedOptions['ODRD(Actual) route'] && this.mapData && this.mapData.odrdPolyline) {
            var encodedStr = this.mapData.odrdPolyline;
            var finalPath = google.maps.geometry.encoding.decodePath(encodedStr);
            for (var i = 0; i < finalPath.length; i++) {
                this.extendBounds(finalPath[i]);
            }
            this.finalRoute = new google.maps.Polyline({
                path: finalPath,
                geodesic: true,
                strokeColor: '#000099',
                strokeOpacity: 1.0,
                strokeWeight: 3
            });
            this.startedFinalMarker.setIcon(this.polyStart);
            this.startedFinalMarker.setPosition(this.finalRoute.getPath().getAt(0));
            this.startedFinalMarker.setMap(this.map);
            var infowindow = new google.maps.InfoWindow({
                content: 'Customer pickup location',
            });
            infowindow.open(this.map, this.startedFinalMarker);
            this.endFinalMarker.setIcon(this.polyEnd);
            this.endFinalMarker.setPosition(this.finalRoute.getPath().getAt(this.finalRoute.getPath().getLength() - 1));
            this.endFinalMarker.setMap(this.map);
            var infowindow2 = new google.maps.InfoWindow({
                content: 'Customer drop location',
            });
            infowindow2.open(this.map, this.endFinalMarker);
            this.finalRoute.setMap(this.map);
        }
        else {
            if (this.finalRoute) {
                this.finalRoute.setMap(null);
                this.startedFinalMarker.setMap(null);
                this.endFinalMarker.setMap(null);
            }
        }
    };
    RideTrackerMapComponent.prototype.toggleActualRoute = function () {
        if (this.selectedOptions['Last Mile Travelled(hF)']) {
            var points = this.actualLatLngs['locations'];
            for (var position in points) {
                if (points[position]) {
                    if (points[position].location && points[position].location[0] && points[position].location[1]) {
                        var latLng = { lat: points[position].location[1], lng: points[position].location[0] };
                        // this.extendBounds(latLng);
                        this.actualRoute[position] = new google.maps.Marker({
                            icon: this.actualRouteMarker
                        });
                        this.actualRoute[position].setPosition(latLng);
                        this.actualRoute[position].setMap(this.map);
                    }
                }
            }
        }
        else {
            if (this.actualRoute.length > 0) {
                for (var position in this.actualRoute) {
                    if (this.actualRoute[position]) {
                        this.actualRoute[position].setMap(null);
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.toggleAcceptToArriveRoute = function () {
        if (this.selectedOptions['First Mile Travelled']) {
            var locations = this.acceptToArriveLatLngs['locations'];
            for (var position in locations) {
                if (locations[position]) {
                    if (locations[position].location && locations[position].location[0] && locations[position].location[1]) {
                        var latLng = { lat: locations[position].location[1], lng: locations[position].location[0] };
                        // this.extendBounds(latLng);
                        this.acceptToArriveRoute[position] = new google.maps.Marker({
                            icon: this.acceptToArriveRouteMarker
                        });
                        this.acceptToArriveRoute[position].setPosition(latLng);
                        this.acceptToArriveRoute[position].setMap(this.map);
                    }
                }
            }
        }
        else {
            if (this.acceptToArriveRoute.length > 0) {
                for (var position in this.acceptToArriveRoute) {
                    if (this.acceptToArriveRoute[position]) {
                        this.acceptToArriveRoute[position].setMap(null);
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.toggleOtherRoutes = function () {
        if (this.selectedOptions['Alternate routes']) {
            var otherRoutes = _.cloneDeep(this.mapData.fareEstimateLogs[0].direction.allPaths);
            var otherRoutesGoogle = otherRoutes.splice(1, 2);
            for (var path in otherRoutesGoogle) {
                if (otherRoutesGoogle[path]) {
                    var encodedStr = otherRoutesGoogle[path]['polyline'];
                    var otherPath = google.maps.geometry.encoding.decodePath(encodedStr);
                    this.otherRoutes[path] = new google.maps.Polyline({
                        path: otherPath,
                        geodesic: true,
                        strokeColor: this.colorsForOtherRoutes[path],
                        strokeOpacity: 1.0,
                        strokeWeight: 3
                    });
                    this.startedOtherMarker[path] = new google.maps.Marker({
                        position: this.otherRoutes[path].getPath().getAt(0),
                        map: this.map,
                        icon: this.polyStart
                    });
                    this.endOtherMarker[path] = new google.maps.Marker({
                        position: this.otherRoutes[path].getPath().getAt(this.otherRoutes[path].getPath().getLength() - 1),
                        map: this.map,
                        icon: this.polyEnd
                    });
                    for (var i = 0; i < otherPath.length; i++) {
                        // this.extendBounds(otherPath[i]);
                    }
                    this.otherRoutes[path].setMap(this.map);
                }
            }
        }
        else {
            if (this.otherRoutes && this.otherRoutes.length > 0) {
                for (var route in this.otherRoutes) {
                    if (this.otherRoutes[route]) {
                        this.otherRoutes[route].setMap(null);
                        this.startedOtherMarker[route].setMap(null);
                        this.endOtherMarker[route].setMap(null);
                    }
                }
            }
        }
    };
    RideTrackerMapComponent.prototype.extendBounds = function (location) {
        this.bound.extend(location);
        this.map.fitBounds(this.bound, 100);
        // this.map.setZoom(12);
    };
    RideTrackerMapComponent.prototype.differenceTimestamps = function (date1, date2) {
        var res = Math.abs(date1 - date2) / 1000;
        // get total days between two dates
        var days = (res / 86400);
        // get hours
        var hours = (res / 3600) % 24;
        // get minutes
        var minutes = (res / 60) % 60;
        return minutes;
    };
    RideTrackerMapComponent.prototype.openFullView = function () {
        var fullMapObj = { routes: this.mapData, actualRoute: this.actualLatLngs, orderStatus: this.orderStatus,
            captLiveLocInOrderLogs: this.captLiveLocInOrderLogs, cancellationInformation: this.cancellationInformation,
            riderId: this.riderIdForOrder, captLiveCoords: this.captLiveCoords, captainCurrentStatus: this.captainCurrentStatus,
            acceptToArriveRoute: this.acceptToArriveLatLngs, options: this.slideOptions, selectedOptions: this.selectedOptions,
            acceptRouteTitle: this.acceptRouteTitle, cityBoundaryPolygon: this.cityBoundaryPolygon, orderCityId: this.orderCityId,
            cityTolls: this.cityTolls,
            events: { requestedEvent: this.requestedEvent, startedEvent: this.startedEvent },
            isServiceDeliveryType: this.isServiceDeliveryType
        };
        this.fullViewMap.emit(fullMapObj);
    };
    RideTrackerMapComponent.prototype.togglePopulateTolls = function () {
        var _this = this;
        if (this.selectedOptions['Tolls']) {
            this.tollEnabled = true;
            if (this.cityTolls.length == 0) {
                this.rideTrackerMapService.getCityTolls(this.orderCityId).subscribe(function (result) {
                    if (result) {
                        _this.cityTolls = result['tolls'];
                        _this.tollPolylines = _this.tollService.addTollsToMap(_this.cityTolls, _this.map);
                        var tollLines = _this.tollService.fetchTollLinesFromTolls(_this.cityTolls);
                        _this.cityEntryTollLines = tollLines.entryTollLines;
                        _this.cityExitTollLines = tollLines.exitTollLines;
                    }
                }, function (error) {
                    if (error) {
                        _this.selectedOptions['Tolls'] = false;
                        _this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Toll fetch failed'
                        }));
                    }
                });
            }
            else {
                this.tollPolylines = this.tollService.addTollsToMap(this.cityTolls, this.map);
            }
        }
        else {
            this.tollEnabled = false;
            this.tollService.removeTollsFromMap(this.map, this.tollPolylines);
        }
    };
    RideTrackerMapComponent.prototype.toggleGuestRoute = function () {
        var _this = this;
        if (this.selectedOptions['Guest Route']) {
            if (this.guestTripData) {
                // Data already fetched, just display it
                this.displayGuestRoute();
            }
            else if (this.poolInfo && this.poolInfo.guestTripId) {
                // Fetch the trip data from API
                this.rideTrackerMapService.getTripsBulk([this.poolInfo.guestTripId], this.poolInfo.tripDate).subscribe(function (result) {
                    var trip = HelperService.tripFromBulkResponse(result, _this.poolInfo.guestTripId, _this.poolInfo.tripDate);
                    if (trip) {
                        _this.guestTripData = trip;
                        _this.constructSideBar();
                        _this.displayGuestRoute();
                    }
                    else {
                        _this.selectedOptions['Guest Route'] = false;
                        _this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Failed to fetch guest route'
                        }));
                    }
                }, function (error) {
                    _this.selectedOptions['Guest Route'] = false;
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: 'Failed to fetch guest route'
                    }));
                });
            }
            else {
                this.selectedOptions['Guest Route'] = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: 'Guest trip ID not available'
                }));
            }
        }
        else {
            // Hide the guest route
            if (this.guestRoute) {
                this.guestRoute.setMap(null);
            }
            this.startedGuestMarker.setMap(null);
            this.endGuestMarker.setMap(null);
            // Close InfoWindows
            if (this.guestStartInfoWindow) {
                this.guestStartInfoWindow.close();
            }
            if (this.guestEndInfoWindow) {
                this.guestEndInfoWindow.close();
            }
        }
    };
    RideTrackerMapComponent.prototype.displayGuestRoute = function () {
        if (this.guestTripData && this.guestTripData.routeDetails && this.guestTripData.routeDetails.polyline) {
            var encodedStr = this.guestTripData.routeDetails.polyline;
            var guestPath = google.maps.geometry.encoding.decodePath(encodedStr);
            if (this.guestRoute) {
                this.guestRoute.setMap(null);
            }
            this.guestRoute = new google.maps.Polyline({
                path: guestPath,
                geodesic: true,
                strokeColor: '#FF6B6B',
                strokeOpacity: 1.0,
                strokeWeight: 3
            });
            this.startedGuestMarker.setIcon(this.polyStart);
            this.startedGuestMarker.setPosition(this.guestRoute.getPath().getAt(0));
            this.startedGuestMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.guestStartInfoWindow) {
                this.guestStartInfoWindow.close();
            }
            this.guestStartInfoWindow = new google.maps.InfoWindow({
                content: 'Guest pickup location',
            });
            this.guestStartInfoWindow.open(this.map, this.startedGuestMarker);
            this.endGuestMarker.setIcon(this.polyEnd);
            this.endGuestMarker.setPosition(this.guestRoute.getPath().getAt(this.guestRoute.getPath().getLength() - 1));
            this.endGuestMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.guestEndInfoWindow) {
                this.guestEndInfoWindow.close();
            }
            this.guestEndInfoWindow = new google.maps.InfoWindow({
                content: 'Guest drop location',
            });
            this.guestEndInfoWindow.open(this.map, this.endGuestMarker);
            for (var i = 0; i < guestPath.length; i++) {
                this.extendBounds(guestPath[i]);
            }
            this.guestRoute.setMap(this.map);
        }
    };
    RideTrackerMapComponent.prototype.toggleHostRoute = function () {
        var _this = this;
        if (this.selectedOptions['Host Route']) {
            if (this.hostTripData) {
                // Data already fetched, just display it
                this.displayHostRoute();
            }
            else if (this.poolInfo && this.poolInfo.hostTripId) {
                // Fetch the trip data from API
                this.rideTrackerMapService.getTripsBulk([this.poolInfo.hostTripId], this.poolInfo.tripDate).subscribe(function (result) {
                    var trip = HelperService.tripFromBulkResponse(result, _this.poolInfo.hostTripId, _this.poolInfo.tripDate);
                    if (trip) {
                        _this.hostTripData = trip;
                        _this.constructSideBar();
                        _this.displayHostRoute();
                    }
                    else {
                        _this.selectedOptions['Host Route'] = false;
                        _this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Failed to fetch host route'
                        }));
                    }
                }, function (error) {
                    _this.selectedOptions['Host Route'] = false;
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: 'Failed to fetch host route'
                    }));
                });
            }
            else {
                this.selectedOptions['Host Route'] = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: 'Host trip ID not available'
                }));
            }
        }
        else {
            // Hide the host route
            if (this.hostRoute) {
                this.hostRoute.setMap(null);
            }
            this.startedHostMarker.setMap(null);
            this.endHostMarker.setMap(null);
            // Close InfoWindows
            if (this.hostStartInfoWindow) {
                this.hostStartInfoWindow.close();
            }
            if (this.hostEndInfoWindow) {
                this.hostEndInfoWindow.close();
            }
        }
    };
    RideTrackerMapComponent.prototype.displayHostRoute = function () {
        if (this.hostTripData && this.hostTripData.routeDetails && this.hostTripData.routeDetails.polyline) {
            var encodedStr = this.hostTripData.routeDetails.polyline;
            var hostPath = google.maps.geometry.encoding.decodePath(encodedStr);
            if (this.hostRoute) {
                this.hostRoute.setMap(null);
            }
            this.hostRoute = new google.maps.Polyline({
                path: hostPath,
                geodesic: true,
                strokeColor: '#ffbe0b',
                strokeOpacity: 1.0,
                strokeWeight: 3
            });
            this.startedHostMarker.setIcon(this.polyStart);
            this.startedHostMarker.setPosition(this.hostRoute.getPath().getAt(0));
            this.startedHostMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.hostStartInfoWindow) {
                this.hostStartInfoWindow.close();
            }
            this.hostStartInfoWindow = new google.maps.InfoWindow({
                content: 'Host pickup location',
            });
            this.hostStartInfoWindow.open(this.map, this.startedHostMarker);
            this.endHostMarker.setIcon(this.polyEnd);
            this.endHostMarker.setPosition(this.hostRoute.getPath().getAt(this.hostRoute.getPath().getLength() - 1));
            this.endHostMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.hostEndInfoWindow) {
                this.hostEndInfoWindow.close();
            }
            this.hostEndInfoWindow = new google.maps.InfoWindow({
                content: 'Host drop location',
            });
            this.hostEndInfoWindow.open(this.map, this.endHostMarker);
            for (var i = 0; i < hostPath.length; i++) {
                this.extendBounds(hostPath[i]);
            }
            this.hostRoute.setMap(this.map);
        }
    };
    RideTrackerMapComponent.prototype.toggleMatchRoute = function () {
        var _this = this;
        if (this.selectedOptions['Match Route']) {
            if (this.tripMatchData) {
                // Data already fetched, just display it
                this.displayMatchRoute();
            }
            else if (this.poolInfo && this.poolInfo.tripMatchId) {
                // Fetch the trip match data from API
                this.rideTrackerMapService.getPoolTripMatchById(this.poolInfo.tripMatchId).subscribe(function (result) {
                    if (result && result['data']) {
                        _this.tripMatchData = result['data'];
                        _this.constructSideBar();
                        _this.displayMatchRoute();
                    }
                    else if (result && result['id']) {
                        // Direct trip match object response
                        _this.tripMatchData = result;
                        _this.constructSideBar();
                        _this.displayMatchRoute();
                    }
                }, function (error) {
                    _this.selectedOptions['Match Route'] = false;
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: 'Failed to fetch match route'
                    }));
                });
            }
            else {
                this.selectedOptions['Match Route'] = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: 'Trip match ID not available'
                }));
            }
        }
        else {
            // Hide the match route
            if (this.matchRoute) {
                this.matchRoute.setMap(null);
            }
            this.startedMatchMarker.setMap(null);
            this.endMatchMarker.setMap(null);
            // Close InfoWindows
            if (this.matchStartInfoWindow) {
                this.matchStartInfoWindow.close();
            }
            if (this.matchEndInfoWindow) {
                this.matchEndInfoWindow.close();
            }
        }
    };
    RideTrackerMapComponent.prototype.displayMatchRoute = function () {
        if (this.tripMatchData && this.tripMatchData.pricing && this.tripMatchData.pricing.polyline) {
            var encodedStr = this.tripMatchData.pricing.polyline;
            var matchPath = google.maps.geometry.encoding.decodePath(encodedStr);
            if (this.matchRoute) {
                this.matchRoute.setMap(null);
            }
            this.matchRoute = new google.maps.Polyline({
                path: matchPath,
                geodesic: true,
                strokeColor: '#8338ec',
                strokeOpacity: 1.0,
                strokeWeight: 3
            });
            this.startedMatchMarker.setIcon(this.polyStart);
            this.startedMatchMarker.setPosition(this.matchRoute.getPath().getAt(0));
            this.startedMatchMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.matchStartInfoWindow) {
                this.matchStartInfoWindow.close();
            }
            this.matchStartInfoWindow = new google.maps.InfoWindow({
                content: 'HopIn',
            });
            this.matchStartInfoWindow.open(this.map, this.startedMatchMarker);
            this.endMatchMarker.setIcon(this.polyEnd);
            this.endMatchMarker.setPosition(this.matchRoute.getPath().getAt(this.matchRoute.getPath().getLength() - 1));
            this.endMatchMarker.setMap(this.map);
            // Close existing InfoWindow if it exists
            if (this.matchEndInfoWindow) {
                this.matchEndInfoWindow.close();
            }
            this.matchEndInfoWindow = new google.maps.InfoWindow({
                content: 'HopOut',
            });
            this.matchEndInfoWindow.open(this.map, this.endMatchMarker);
            for (var i = 0; i < matchPath.length; i++) {
                this.extendBounds(matchPath[i]);
            }
            this.matchRoute.setMap(this.map);
        }
    };
    return RideTrackerMapComponent;
}());
export { RideTrackerMapComponent };
